import Home from "~/themes/unicredit/components/Home.vue";
import PersonalCredit from "~/components/forms/RatePersonalCredit.vue";
import EmailPrivacy from "~/themes/unicredit/components/forms/EmailPrivacy.vue";
import Contacts from "~/components/forms/Contacts.vue";
import PersonalData from "~/components/forms/PersonalData.vue";
import IncomeData from "~/components/forms/IncomeData.vue";
import EmployerData from "~/components/forms/EmployerDataShort.vue";
import ClubConsent from "~/themes/unicredit/components/forms/ClubUciConsent.vue";
import ClubWarning from "~/themes/unicredit/components/forms/ClubUciWarning.vue";
import DeliveryData from "~/components/forms/DeliveryData.vue";
import IdentityDocData from "~/components/forms/IdentityDocData.vue";
import PaymentData from "~/components/forms/PaymentData.vue";
import Typ from "~/components/typ/Typ.vue";
import TypKO from "~/components/typ/TypKO.vue";
import Promo from "~/components/forms/Promo.vue";

export default {
  Home,
  PersonalCredit,
  EmailPrivacy,
  Contacts,
  PersonalData,
  IncomeData,
  EmployerData,
  ClubConsent,
  ClubWarning,
  DeliveryData,
  IdentityDocData,
  PaymentData,
  Promo,
  Typ,
  TypKO
};
